import { useQuery } from "@tanstack/react-query";
import { getCkycFlows } from "../../../../service/order/orderService";
import { CKYC_FLOWS_QUERY_KEY } from "./kycConstants";

// Which CKYC flows the backend has enabled; only fetched while the KYC modal is open.
const useCkycFlows = (enabled) =>
  useQuery({ queryKey: CKYC_FLOWS_QUERY_KEY, queryFn: getCkycFlows, enabled });

export default useCkycFlows;
